export default __webpack_public_path__ + "static/media/sdp-logo.26ccdc35.svg";